import { displayGroupDetails } from "../../../../Store/slices/ui-slice";
import { store } from "../../../../Store/store/store";

const { dispatch } = store;

export function viewGroupDetails() {
  dispatch(displayGroupDetails(true));
}
